const isOwnRequest = (url) => {
  if (!url) return false;
  if (url.startsWith('/')) return true;
  try {
    return new URL(url).hostname === window.location.hostname;
  } catch {
    return false;
  }
};

// base configuration across all pages and views
App.namespace('setup', () => {
  // hold all document ready events until setup is initiated
  $.holdReady(true);

  const init = () => {
    Rollbar.configure({
      onSendCallback(isUncaught, args, payload) {
        const body = payload.body || {};
        const message = body.message || {};
        const extra = message.extra || {};

        // Don't report failed error reporting request to prevent infinite loop
        if (extra.url === window.__DATA_TRACKING_ENDPOINT_ERROR) {
          return;
        }

        // Don't forward rate limiting errors from our own domain to the tracking endpoint
        if (extra.status === 429 && isOwnRequest(extra.url)) {
          return;
        }

        const trace = body.trace || {};
        const exception = trace.exception || {};

        const errorMessage = message.body || exception.message;

        App.track.error({
          rollbarID: payload.uuid,
          message: errorMessage,
          level: payload.level,
          type: extra.type,
          responseCode: extra.status,
          requestedUrl: extra.url,
        });
      },
    });

    $.ajaxPrefilter((options, originalOptions, jqXHR) => {
      options.error = $.noop();
      const dfd = $.Deferred();
      jqXHR.done(dfd.resolve);
      jqXHR.fail((...args) => {
        if (jqXHR.status === 401) {
          window.onbeforeunload = null;
          window.location.reload();
        } else {
          if (originalOptions.error) { dfd.fail(originalOptions.error); }
          dfd.rejectWith(jqXHR, args);
        }
      });
      return dfd.promise(jqXHR);
    });

    $(document).ajaxError((event, response, request, error) => {
      // ignore errors caused by lost internet connection
      if (response.status === 0 || request.url === window.__DATA_TRACKING_ENDPOINT || response.status === 422) {
        return;
      }

      const errorLevel = response.status >= 500 ? 'error' : 'warning';

      Rollbar[errorLevel](`Ajax ${errorLevel}: ${response.status} on ${request.type}:${request.url}`, {
        url: request.url,
        status: response.status,
        statusText: response.statusText,
        responseText: response.responseText,
        type: request.type,
        data: request.data,
        error,
      });
    });

    $.holdReady(false);
  };

  setTimeout(init);
});
